var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import SearchBar from '../search-bar';
import SessionList from '../session-list';
import { When, Select } from '@alife/simple-ui';
import { Button } from '@alife/simple-ui';
import Icon from '@alife/next-icon';
var ReadType;
(function (ReadType) {
    ReadType["all"] = "All";
    ReadType["unread"] = "Unread";
    ReadType["read"] = "Read";
})(ReadType || (ReadType = {}));
var defaultLocal = {
    draft: 'Draft',
    all: 'All',
    unread: 'Unread',
    read: 'Read'
};
var SessionLayout = (function (_super) {
    __extends(SessionLayout, _super);
    function SessionLayout(props) {
        var _this = _super.call(this, props) || this;
        var locale = props.locale;
        _this.state = {
            visibleSessionList: props.sessionList,
            keyword: '',
            readType: ReadType.all,
            agentId: 'all',
            options: [{
                    value: ReadType.all,
                    label: "" + locale.all
                }, {
                    value: ReadType.unread,
                    label: "" + locale.unread
                }]
        };
        _this.changeKeyword = _this.changeKeyword.bind(_this);
        _this.changeType = _this.changeType.bind(_this);
        _this.changeAgent = _this.changeAgent.bind(_this);
        return _this;
    }
    SessionLayout.prototype.componentWillReceiveProps = function (nextProps) {
        var isSearchFinished = nextProps.activeSessionId !== this.props.activeSessionId && this.state.keyword;
        var newKeyword = isSearchFinished ? '' : this.state.keyword;
        this.updateSessionList({
            sessionList: nextProps.sessionList,
            keyword: newKeyword,
        });
    };
    SessionLayout.prototype.componentDidMount = function () {
        var defaultAgentId = this.props.defaultAgentId;
        if (!defaultAgentId) {
            return;
        }
        this.updateSessionList({
            sessionList: this.props.sessionList,
            agentId: defaultAgentId,
        });
    };
    SessionLayout.prototype.getOptionData = function (sessionList) {
        var locale = this.props.locale;
        var unreadCount = sessionList.reduce(function (count, item) { return count + (item.nonReadNumber > 0 ? 1 : 0); }, 0);
        return [{
                value: ReadType.all,
                label: locale.all + " (" + sessionList.length + ")"
            }, {
                value: ReadType.unread,
                label: locale.unread + " (" + unreadCount + ")"
            }];
    };
    SessionLayout.prototype.updateSessionList = function (_a) {
        var _b = _a.sessionList, sessionList = _b === void 0 ? this.props.sessionList : _b, _c = _a.readType, readType = _c === void 0 ? this.state.readType : _c, _d = _a.keyword, keyword = _d === void 0 ? this.state.keyword : _d, _e = _a.agentId, agentId = _e === void 0 ? this.state.agentId : _e;
        var activeSessionId = this.props.activeSessionId;
        var regex = new RegExp(keyword, 'i');
        var validate = function (item) {
            var isAgentValidate = (agentId == "all" || item.shuntedUserId == agentId);
            var isNameValidate = !!regex.test(item.title);
            return (isAgentValidate && isNameValidate) || item.sessionId === activeSessionId;
        };
        var validateSessionList = sessionList.filter(validate);
        var visibleSessionList = validateSessionList.filter(function (item) {
            return readType === ReadType.all
                || (readType === ReadType.unread && item.nonReadNumber > 0)
                || (readType === ReadType.read && item.nonReadNumber === 0)
                || item.sessionId === activeSessionId;
        });
        var options = this.getOptionData(validateSessionList);
        this.setState({
            visibleSessionList: visibleSessionList,
            readType: readType,
            keyword: keyword,
            agentId: agentId,
            options: options
        });
    };
    SessionLayout.prototype.changeType = function (readType) {
        this.updateSessionList({
            readType: readType,
        });
    };
    SessionLayout.prototype.changeKeyword = function (keyword) {
        this.updateSessionList({
            keyword: keyword,
        });
    };
    SessionLayout.prototype.changeAgent = function (agentId) {
        this.updateSessionList({
            agentId: agentId
        });
    };
    SessionLayout.prototype.render = function () {
        var _a = this.props, locale = _a.locale, _b = _a.displaySearchBar, displaySearchBar = _b === void 0 ? true : _b, _c = _a.displayFilter, displayFilter = _c === void 0 ? false : _c, _d = _a.filterList, filterList = _d === void 0 ? [] : _d, bulkAssign = _a.bulkAssign, defaultAgentId = _a.defaultAgentId;
        var _e = this.state, visibleSessionList = _e.visibleSessionList, keyword = _e.keyword, readType = _e.readType, options = _e.options, agentId = _e.agentId;
        var offline = agentId == "-1";
        return (React.createElement("div", { className: "session-layout" },
            React.createElement(When, { condition: displayFilter },
                React.createElement(Select, { className: "agent-filter", options: filterList, defaultValue: defaultAgentId, onChange: this.changeAgent })),
            React.createElement(When, { condition: offline },
                React.createElement(Button, { className: "primary assign-all", onClick: bulkAssign },
                    React.createElement(Icon, { className: "icon", type: "assignment-return", size: "small" }),
                    locale.assignAll)),
            React.createElement(When, { condition: displaySearchBar && !offline },
                React.createElement(SearchBar, { changeKeyword: this.changeKeyword, changeType: this.changeType, locale: locale, keyword: keyword, readType: readType, options: options })),
            React.createElement(SessionList, __assign({}, this.props, { sessionList: visibleSessionList, locale: locale, keyword: keyword }))));
    };
    SessionLayout.defaultProps = {
        locale: defaultLocal,
        defaultAgentId: 0
    };
    return SessionLayout;
}(React.Component));
export default SessionLayout;
//# sourceMappingURL=index.js.map